import { AntdEditInferencer } from '@refinedev/inferencer/antd'
import Cw8Edit from 'components/cw8/Cw8Edit';

const EditResources = () => {
  const resourceName :string = "recursoInfografia";
  return (
      <Cw8Edit
          resourceName = {resourceName}
      ></Cw8Edit>
  );
}

export default EditResources